module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Abbreviations#fm-1"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#fm-2"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-3"
    }
  }, [_vm._v("Introduction: In Search of a New Methodological Vision for Constructive Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_vm._v("PART I: HOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("1. Introduction: On the Possibility and Conditions of a Constructive Christian Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-1"
    }
  }, [_c('em', [_vm._v("The (Omni)Presence of Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-2"
    }
  }, [_c('em', [_vm._v("On the Conditions and Requirements of a Comprehensive Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_c('em', [_vm._v("Orientation to Part 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_vm._v("2. The “End” of the Cosmos and Life in Natural Sciences’ Conjectures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-4"
    }
  }, [_c('em', [_vm._v("The Origins of the Universe in Light of Contemporary Science")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-5"
    }
  }, [_c('em', [_vm._v("Big Bang Cosmologies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-6"
    }
  }, [_c('em', [_vm._v("Scientific Predictions about the “Future” of the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#sec-7"
    }
  }, [_c('em', [_vm._v("Sciences and Theology in Critical Mutual Dialogue about “Eschatology”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/011_Chapter03#ch-3"
    }
  }, [_vm._v("3. Eschatological Visions and Symbols among Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#sec-8"
    }
  }, [_c('em', [_vm._v("On the Propriety and Conditions of Speaking of Religions’ “Eschatologies”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#sec-9"
    }
  }, [_c('em', [_vm._v("Jewish Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#sec-10"
    }
  }, [_c('em', [_vm._v("Islamic Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#sec-11"
    }
  }, [_c('em', [_vm._v("“End-Time” Visions and Symbols in Hindu Traditions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#sec-12"
    }
  }, [_c('em', [_vm._v("Buddhist Visions of End and “Release”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Trinitarian Theology of Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("For Orientation: Creation, Providence, and Final Consummation as the Joint Work of the Triune God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("God of Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Resurrection of the Son as the Basis of Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Perfecting Work of the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Transition from Time to Eternity and New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Introduction: The Power of Anticipation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Time-Space and Eternity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Transition from Time to Eternity: The Dynamic of Continuity and Discontinuity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Judgment, Purification, and Reconciliation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Resurrection as the Destiny of the Cosmos and Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Cosmic Significance of Jesus’ Resurrection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Death—the “Last Enemy”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Resurrection as Human Destiny")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Competing Views of the Afterlife")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Flourishing of Nature and Humanity in the Perspective of New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Liberating Eschatology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Flourishing of Nature and Eschatological Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Overcoming Evil and Defeating Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Theodicy in Christian Theology: A Need for Revision and Reassessment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Overcoming Evil as the Ultimate Eschatological Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Evil and Suffering among Religions: The Challenge to Abrahamic Traditions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Defeating Violence and Establishing Peace in the Eschaton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap0"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Christian Theology of Religious Ends in the Pluralistic World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Traditional Theology of Two Destinies and Its Rebuttals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Appeal and Problems of Universalisms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Consummation: “New Heavens and New Earth”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("“The End Is Nigh”: The Ambivalence and Dynamic of the Imminent Return of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Critical and Inspiring Role of the Millennium as the Penultimate Earthly Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Theological Rediscovery of “Heaven”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: COMMUNITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Introduction: The Christian Church and Ecclesiology in the Matrix of Secularism(s) and Religious Pluralism(s)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("How to Do Ecclesiology in the Beginning of the Third Millennium")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Many Facets of the “Globalization” of the Christian Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Continuing Transformations and Changes in Ecclesial Life and Structures in the Global Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Pluralism(s) and Secularism(s) as Ecclesiological Challenges")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Brief Orientation to Part 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Visions of Community among Religions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Synagogue—the Jewish Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ummah"), _c('em', [_vm._v("—the Islamic Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Hindu Spiritual Life and Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Buddhist")]), _vm._v(" Sangha "), _c('em', [_vm._v("and Spiritual Pursuit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Community after the Trinity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Trinitarian “Foundation” of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Church as the Image of the Trinity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter13#sec-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Church of the Triune God as an Eschatological Anticipation of the Kingdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/023_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Ecclesiality of the Church: An Ecumenical Proposal and Appeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("What Is at Stake in the Discussion of Ecclesiality?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Toward a Mutual Recognition of the Ecclesiality of the Church: A Constructive Proposal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter14#sec-50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Four Marks of the Church in Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Church as Communion of Communions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#sec-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Trinitarian Communion as the Source of Ecclesial Communion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#sec-52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Rich and Multidimensional Nature of")]), _vm._v(" Koinonia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#sec-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Communion of Communions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#sec-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Wider Context of the “Communion of Saints” in Relation to the Deceased and Ancestors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter15#sec-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Identity, Alienation, and Belonging: Communion Ecclesiology as “Contextual Theology” for the Postmodern World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Church as Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter16#sec-56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mission in the New Context(s)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter16#sec-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Missional Nature of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter16#sec-58",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Multidimensional Mission in the Service of the Coming of God’s Kingdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Missional Existence as the Sacramental and Liturgical Celebration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter17#sec-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Liturgy and Worship at the Heart of the Church’s Missional Existence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter17#sec-60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Sacramental Life of the Missional Communion in a Theological Outlook")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter17#sec-61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Baptism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter17#sec-62",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eucharist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Missional Existence as the Charismatic-Diaconal Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter18#sec-63",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The People of God as the Missional Minister")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter18#sec-64",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Charismatic Structure of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter18#sec-65",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Missional Organization of the Community Structures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter18#sec-66",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ordained Ministers in the Service of the Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/028_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Missional Existence as the Pursuit of the Diversified and Plural Unity of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter19#sec-67",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Task and Landscape in the Search for the Unity of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter19#sec-68",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Toward Mutual Recognition of Churches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter19#sec-69",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Further New Resources and Fresh Perspectives on the Way toward Recognition and Unity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Missional Existence as Hospitable Dialogue: The Church among Religious Communities and Secularisms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-70",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Methodological Orientation: Christian Theology as Comparative Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-71",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Pluralisms in a Theological Assessment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-72",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Trinitarian Theology of Interfaith Hospitality of Witness and Dialogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-73",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Church and the Synagogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-74",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Church and")]), _vm._v(" Ummah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-75",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Church and Hindus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-76",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Church and Buddhists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter20#sec-77",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Christian Church and Ecclesiology in the “Secular City”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: In the End—the Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Epilogue#sec-78",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Trinitarian Unfolding of Divine Economy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Epilogue#sec-79",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("In Search of a Proper Confidence Rather Than Indubitable Certainty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Bibliography#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab1813c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0